import { isProdEnv } from "lib/routing";
import { JAPI } from "redux/slices/api/initialisePreferences";
import { hasPreference, useHasPreference } from "api/preferences/useGetPreferences";
import { getAssetClass } from "../../pages/redesign/publications/api/searchRequest/urlHelpers";
import { ASSET_CLASSES } from "../../pages/redesign/header/desktop/DesktopHeaderParts/DesktopHeaderParts";

export const useProdCopyUrl = () => {
  const isProdCopy = useHasPreference(JAPI, "Production");
  return isProdCopy && !isProdEnv ? "japi-prodcopy" : "japi";
};

export const getProdCopyUrl = () => {
  const isProdCopy = hasPreference(JAPI, "Production");
  return isProdCopy && !isProdEnv ? "japi-prodcopy" : "japi";
};

// TODO: Refactor below function to remove assetClass SP/Credit check
export const isAssetClassOrHomePage = () => {
  let assetClass = getAssetClass();
  assetClass = assetClass === "SP__Credit" ? "SP/Credit" : assetClass;
  const isLandingPage = assetClass.toLowerCase() === "topics";

  return ASSET_CLASSES.includes(assetClass) || !!isLandingPage;
};
